import type { Icon } from '../../../src/lib/types'
export const mdiFormatIndentDecrease: Icon = {
  "id": "format-indent-decrease",
  "name": "Format Indent Decrease",
  "path": "M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M3,21H21V19H3M3,12L7,16V8M11,17H21V15H11V17Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatIndentDecrease